import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportApiService } from 'src/app/services/report.api.service';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CustomDateAdapter } from 'src/app/Modules/idms/core/custom-date-adapter';

@Component({
    selector: 'app-report-subscription-add',
    templateUrl: './report-subscription-add.component.html',
    styleUrls: ['./report-subscription-add.component.scss'],
    providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }],
    standalone: false,
})
export class ReportSubscriptionAddComponent implements OnDestroy {
    @Output() showpanelconfirm = new EventEmitter();
    @Output() instance_next_TabEvent = new EventEmitter<any>();
    @Output() RemoveEvent = new EventEmitter<any>();
    destroy$ = new Subject();

    searchText;
    myreport;
    radio_btn_value: string = '';
    tooltip_position = 'above';
    reportName: string;
    color: ThemePalette = 'primary';
    mode: ProgressSpinnerMode = 'determinate';
    value = 50;
    message: any;
    scheduleForm: FormGroup;
    fileType: any[];
    Days: any;
    DayList: any;
    DayListCopy: any;
    reportId: string;
    fileTypeList: any;
    MonthList: any;
    subscriptionData: any;
    title: string;
    activityPackTypeId: string;
    activityPackStatusIds: any;
    activityPackIds: string;
    fromDate: string;
    projectTypesCopy: any[];
    projectTypes: any[];
    activityPackTypes: any[];
    activityPackTypesCopy: any[];
    activityPackStatus: any[];
    activityPackStatusCopy: any[];
    Views: any[];
    ViewsCopy: any[];
    projects: any[];
    workpacks: any[];
    activityPacks: any[];
    projectsCopy: any[];
    workpacksCopy: any[];
    activityPacksCopy: any[];
    checkedIds: any;
    btnTitle: string;
    btnTitle1: string;
    radio_btn_monthly: string = '';
    radio_btn_daily: string = '';
    startTimechecked: boolean = false;
    endTimechecked: boolean = false;
    radio_btn_weekly: string = '';
    chkDisabled: boolean = true;
    selectedOptions: any[];
    activityPackTypeStatusSelected: any[];
    activityPackSelected: any[];
    minDate = new Date(2000, 0, 1); // Jan 1, 2000
    maxDate = new Date(2100, 11, 31); // Dec 31, 2100
    currentDate = new Date(); // today's date
    constructor(
        private modalService: NgbModal,
        private formBuilder: FormBuilder,
        private ngbActiveModal: NgbActiveModal,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private user_utlity: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private reportApiService: ReportApiService,
        private datePipe: DatePipe
    ) {}

    ngOnInit(): void {
        this.MonthList = [
            {
                name: 'January',
                value: '1',
                checked: false,
            },
            {
                name: 'February',
                value: '2',
                checked: false,
            },
            {
                name: 'March',
                value: '4',
                checked: false,
            },
            {
                name: 'April',
                value: '8',
                checked: false,
            },
            {
                name: 'May',
                value: '16',
                checked: false,
            },
            {
                name: 'June',
                value: '32',
                checked: false,
            },
            {
                name: 'July',
                value: '64',
                checked: false,
            },
            {
                name: 'August',
                value: '128',
                checked: false,
            },
            {
                name: 'September',
                value: '256',
                checked: false,
            },
            {
                name: 'October',
                value: '512',
                checked: false,
            },
            {
                name: 'November',
                value: '1024',
                checked: false,
            },
            {
                name: 'December',
                value: '2048',
                checked: false,
            },
        ];
        this.Days = [
            {
                name: 'Monday',
                value: '1',
                checked: false,
            },
            {
                name: 'Tuesday',
                value: '2',
                checked: false,
            },
            {
                name: 'Wednesday',
                value: '4',
                checked: false,
            },
            {
                name: 'Thursday',
                value: '8',
                checked: false,
            },
            {
                name: 'Friday',
                value: '16',
                checked: false,
            },
            {
                name: 'Saturday',
                value: '32',
                checked: false,
            },
            {
                name: 'Sunday',
                value: '64',
                checked: false,
            },
        ];
        this.DayList = this.Days;
        this.DayListCopy = this.Days;

        this.scheduleForm = this.formBuilder.group({
            radio_btn_value: new FormControl(''),
            Name: new FormControl('', [Validators.required]),
            Description: new FormControl(''),
            hours: new FormControl(''),
            radio_btn_daily: new FormControl(''),
            radio_btn_monthly: new FormControl(''),
            day_number: new FormControl(''),
            week_number: new FormControl(''),
            month_number: new FormControl(''),
            start_date: new FormControl(null, [Validators.required]),
            start_hour: new FormControl({ value: '', disabled: true }),
            start_minute: new FormControl({ value: '', disabled: true }),
            end_date: new FormControl({ value: null, disabled: true }),
            to_address: new FormControl('', [commaSeparatedEmailsValidator(), Validators.required]),
            cc_address: new FormControl('', [commaSeparatedEmailsValidator()]),
            bcc_address: new FormControl('', [commaSeparatedEmailsValidator()]),
            Subject: new FormControl('<Report_Name> - Generated on <Run_Date>', [Validators.required]),
            fileTypeValue: new FormControl('', [Validators.required]),
            days: new FormControl(''),
            Weekdays: new FormControl(''),
            radio_btn_weekly: new FormControl(''),
            weekofthemonth: new FormControl('1'),
            MonthList: new FormControl(''),
            MonthDay: new FormControl(''),
            //For Parameters
            selectAll: new FormControl(false),
            activityPackTypeId: new FormControl([]),
            viewId: new FormControl([]),
            activityPackId: new FormControl('-1'),
            activityPackTypeStatusId: new FormControl('-1'),
            activityPackTypeStatusselectAll: new FormControl(false),
            activityPackIdselectAll: new FormControl(false),
            from_date: new UntypedFormControl(null),
            projectTypeId: new FormControl(''),
            projectId: new FormControl(''),
            IsStartTime: new FormControl(''),
            IsEndTime: new FormControl(''),
            enabled: new FormControl(true),
            _activityPackTypeId: new FormControl(''),
            //     days: this.buildDays(), // Checkbox form array
            // },
            // { validators: this.atLeastOneCheckboxChecked
        });
        if (this.fileTypeList?.length == 1) {
            this.scheduleForm.get('fileTypeValue').setValue(String(this.fileTypeList[0].value));
        }
        const textBox = this.scheduleForm.get('radio_btn_value');
        textBox?.setValidators([Validators.required]);
        textBox?.updateValueAndValidity();
        this.FormValueChanges();

        if (this.reportName == 'Work Flow Completion') {
            const control = this.scheduleForm.get('activityPackTypeId');
            control?.setValidators([Validators.required]);
            control?.updateValueAndValidity();
            this.FormValueChanges();
        }
        if (this.reportName == 'View Hierarchy') {
            const control = this.scheduleForm.get('viewId');
            control?.setValidators([Validators.required]);
            control?.updateValueAndValidity();
            this.FormValueChanges();
        }
        if (this.reportName == 'Work Flow Template') {
            const control = this.scheduleForm.get('_activityPackTypeId');
            control?.setValidators([Validators.required]);
            control?.updateValueAndValidity();
            this.FormValueChanges();

            const control1 = this.scheduleForm.get('activityPackTypeStatusId');
            control1?.setValidators([Validators.required]);
            control1?.updateValueAndValidity();
            this.FormValueChanges();

            const control2 = this.scheduleForm.get('activityPackId');
            control2?.setValidators([Validators.required]);
            control2?.updateValueAndValidity();
            this.FormValueChanges();
        }
        if (this.reportName == 'Activity Progress') {
            const control = this.scheduleForm.get('projectTypeId');
            control?.setValidators([Validators.required]);
            control?.updateValueAndValidity();
            this.FormValueChanges();

            const control1 = this.scheduleForm.get('projectId');
            control1?.setValidators([Validators.required]);
            control1?.updateValueAndValidity();
            this.FormValueChanges();
        }
        if (this.subscriptionData) {
            this.setValuesForEdit();
        }
        switch (this.reportName) {
            case 'Work Flow Completion':
                this.getAllActivityPacks();
                break;
            case 'View Hierarchy':
                this.getAllViews();
                break;
            case 'Work Flow Template':
                this.getAllActivityPacks();
                break;
            case 'Activity Progress':
                this.getProjectTypesAndProjects();
                break;
        }
    }

    setCheckedDaysBasedOnBinary(binaryValue: any, ArrayList: any): void {
        // Ensure the binary string is 7 characters long (for 7 days)
        const binaryPadded = binaryValue.padStart(7, '0'); // "1001111"

        // Iterate through the binary string from right to left and map to Days
        ArrayList.forEach((day, index) => {
            const bit = binaryPadded[binaryPadded.length - 1 - index]; // Get the corresponding bit (right to left)
            day.checked = bit === '1'; // Set checked if bit is 1
        });
    }

    FormValueChanges() {
        this.scheduleForm
            .get('radio_btn_value')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (res) => {
                if (res) {
                    this.changeUnit(res);
                }
            });

        this.scheduleForm
            .get('radio_btn_daily')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (res) => {
                if (res) {
                    this.DayListCopy.forEach((day) => (day.checked = false));
                    this.scheduleForm.get(`day_number`).setValue('');
                    this.scheduleForm.get('day_number')?.disable();
                    if (this.radio_btn_value == '2') {
                        this.radio_btn_daily = this.scheduleForm.get(`radio_btn_daily`).value;
                        if (this.radio_btn_daily == 'a') {
                            const textBox = this.scheduleForm.get('days');
                            textBox?.setValidators([Validators.required]);
                            textBox?.updateValueAndValidity();
                        } else if (this.radio_btn_daily == 'c') {
                            const textBox = this.scheduleForm.get('day_number');
                            textBox?.setValidators([Validators.required, Validators.min(1), Validators.max(29)]);
                            textBox?.updateValueAndValidity();
                            this.scheduleForm.get('day_number')?.enable();
                        } else {
                            const textBox = this.scheduleForm.get('day_number');
                            textBox?.clearValidators();
                            textBox?.updateValueAndValidity();
                            const textBox1 = this.scheduleForm.get('days');
                            textBox1?.clearValidators();
                            textBox1?.updateValueAndValidity();
                        }
                    } else {
                        const textBox = this.scheduleForm.get('day_number');
                        textBox?.clearValidators();
                        textBox?.updateValueAndValidity();
                        const textBox1 = this.scheduleForm.get('days');
                        textBox1?.clearValidators();
                        textBox1?.updateValueAndValidity();
                    }
                }
            });

        this.scheduleForm
            .get('radio_btn_monthly')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (res) => {
                if (res) {
                    this.Days.forEach((day) => (day.checked = false));
                    const textBox = this.scheduleForm.get('month_number');
                    textBox.setValue('');
                    textBox?.clearValidators();
                    textBox?.updateValueAndValidity();
                    const MonthDay = this.scheduleForm.get('MonthDay');
                    MonthDay?.clearValidators();
                    MonthDay?.updateValueAndValidity();
                    this.cd.detectChanges();
                    this.scheduleForm.get('month_number')?.disable();
                    if (this.radio_btn_value == '4') {
                        this.radio_btn_monthly = this.scheduleForm.get(`radio_btn_monthly`).value;
                        if (this.radio_btn_monthly == 'b') {
                            const textBox = this.scheduleForm.get('month_number');
                            textBox?.setValidators([Validators.required, commaSeparatedNumberValidator()]);
                            textBox?.updateValueAndValidity();
                            this.scheduleForm.get('month_number')?.enable();
                        } else if (this.radio_btn_monthly == 'a') {
                            const MonthDay = this.scheduleForm.get('MonthDay');
                            MonthDay?.setValidators([Validators.required, Validators.min(1), Validators.max(31)]);
                            MonthDay?.updateValueAndValidity();
                        }
                    }
                }
            });
        ////For Parameters

        this.scheduleForm
            .get('activityPackTypeId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) => (x.length !== this.activityPackTypesCopy.length ? this.scheduleForm.get('selectAll').setValue(false, { emitEvent: false }) : null))
            )
            .subscribe((jointIds) => {
                if (jointIds.length > 0) {
                    this.checkedIds = jointIds;
                }
            });
        this.scheduleForm
            .get('_activityPackTypeId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) => (x?.length !== this.activityPackTypesCopy?.length ? this.scheduleForm.get('selectAll').setValue(false, { emitEvent: false }) : null))
            )
            .subscribe((jointIds) => {
                if (jointIds) {
                    let activityPackType = {
                        activityPackTypeId: String(jointIds),
                    };
                    this.activityPackTypeId = String(jointIds);
                    this.getAllActivityStatus(activityPackType);
                }
            });

        this.scheduleForm
            .get('viewId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (viewId) => {
                if (viewId) {
                    this.checkedIds = viewId;
                }
            });

        this.scheduleForm
            .get('selectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                switch (this.reportName) {
                    case 'Work Flow Completion':
                        // let selectAllData = value ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : [];
                        this.scheduleForm.get('activityPackTypeId').setValue(value ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : []);
                        this.selectedOptions = value ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : [];
                        this.cd.detectChanges();
                        break;
                    case 'View Hierarchy':
                        this.scheduleForm.get('viewId').setValue(value ? this.ViewsCopy.map((x) => x.viewId) : []);
                        break;
                }
            });

        this.scheduleForm
            .get('activityPackTypeStatusselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.scheduleForm.get('activityPackTypeStatusId').setValue(value ? this.activityPackStatusCopy : []);
                this.activityPackTypeStatusSelected = value ? this.activityPackStatusCopy : [];
                this.cd.detectChanges();
            });

        this.scheduleForm
            .get('activityPackTypeStatusId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x?.length !== this.activityPackStatusCopy?.length
                        ? this.scheduleForm.get('activityPackTypeStatusselectAll').setValue(false, { emitEvent: false })
                        : null
                )
            )
            .subscribe((jointIds) => {
                if (jointIds) {
                    let activityPackType = {
                        activityPackTypeId: this.activityPackTypeId,
                        activityPackTypeStatusIds: jointIds.map((x) => x.activityPackTypeStatusId),
                    };
                    this.activityPackStatusIds = jointIds.map((x) => x.activityPackTypeStatusId);
                    this.getAllActivityStatus(activityPackType);
                }
            });

        this.scheduleForm
            .get('activityPackIdselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.scheduleForm.get('activityPackId').setValue(value ? this.activityPacksCopy.map((x) => x.activityPackId) : []);
                this.activityPackSelected = value ? this.activityPacksCopy.map((x) => x.activityPackId) : [];
                // this.cd.detectChanges();
            });

        this.scheduleForm
            .get('activityPackId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x.length !== this.activityPacksCopy?.length ? this.scheduleForm.get('activityPackIdselectAll').setValue(false, { emitEvent: false }) : null
                )
            )
            .subscribe((jointIds) => {
                if (jointIds) {
                    let date = this.scheduleForm.get('from_date').value;
                    if (jointIds.length > 0) {
                        this.activityPackIds = jointIds.map((x) => x.activityPackTypeId);
                    }
                }
            });

        this.scheduleForm
            .get('projectTypeId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (projectTypeId) => {
                if (projectTypeId) {
                    this.scheduleForm.get('projectId').setValue(null);
                    this.getProjectTypesAndProjects();
                }
            });

        this.scheduleForm
            .get('projectId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (projectId) => {
                if (projectId) {
                    this.getProjectTypesAndProjects();
                }
            });

        this.scheduleForm
            .get('IsStartTime')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.startTimecheck(value);
            });

        this.scheduleForm
            .get('IsEndTime')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.scheduleForm.get('end_date')?.enable();
                } else {
                    this.scheduleForm.get('end_date')?.disable();
                    this.scheduleForm.get('end_date').setValue('');
                }
            });
        //For parameters
    }
    setValuesForEdit() {
        this.scheduleForm.get('radio_btn_value').setValue(String(this.subscriptionData.schedule.recurrenceType));
        this.scheduleForm.get('Name').setValue(String(this.subscriptionData.subscription.name));
        this.scheduleForm.get('Description').setValue(this.subscriptionData?.subscription?.comments ? String(this.subscriptionData.subscription.comments) : '');
        this.scheduleForm.get('to_address').setValue(this.subscriptionData?.subscription?.to ? String(this.subscriptionData.subscription.to) : '');
        this.scheduleForm.get('cc_address').setValue(this.subscriptionData?.subscription?.cc ? String(this.subscriptionData.subscription.cc) : '');
        this.scheduleForm.get('bcc_address').setValue(this.subscriptionData?.subscription?.bcc ? String(this.subscriptionData.subscription.bcc) : '');
        this.scheduleForm.get('Subject').setValue(String(this.subscriptionData.subscription.subject));
        this.scheduleForm.get('start_date').setValue(String(this.subscriptionData.schedule.startDate.split('T')[0]));
        this.scheduleForm.get('enabled').setValue(this.subscriptionData.schedule.enabled);

        if (this.subscriptionData.schedule?.endDate) {
            this.scheduleForm
                .get('end_date')
                .setValue(this.subscriptionData?.schedule?.endDate ? String(this.subscriptionData.schedule.endDate.split('T')[0]) : '');
            this.scheduleForm.get('IsEndTime').setValue(true);
            this.endTimechecked = true;
        }
        if (this.subscriptionData.schedule?.startDate) {
            let splitValue = this.subscriptionData.schedule?.startDate.split('T')[1];
            if (splitValue.split(':')[0] > 0 || splitValue.split(':')[1] > 0) {
                this.scheduleForm.get('IsStartTime').setValue(true);
                this.scheduleForm.get('start_hour').setValue(String(splitValue.split(':')[0]));
                this.scheduleForm.get('start_minute').setValue(String(splitValue.split(':')[1]));
                this.startTimechecked = true;
            }
        }
        this.scheduleForm.get('hours').setValue(String(this.subscriptionData.schedule.recurrenceType == 1 ? this.subscriptionData.schedule.interval : ''));

        this.scheduleForm
            .get('radio_btn_daily')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 2 && this.subscriptionData.schedule?.interval
                        ? 'c'
                        : this.subscriptionData.schedule.recurrenceType == 2 && this.subscriptionData.schedule?.daysOfWeek == 127
                          ? 'b'
                          : this.subscriptionData.schedule.recurrenceType == 2 && this.subscriptionData.schedule?.daysOfWeek
                            ? 'a'
                            : ''
                )
            );

        this.scheduleForm
            .get('radio_btn_monthly')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 4 && this.subscriptionData.schedule?.daysOfMonth
                        ? 'b'
                        : this.subscriptionData.schedule.recurrenceType == 4 &&
                            this.subscriptionData.schedule?.daysOfWeek &&
                            this.subscriptionData.schedule?.interval
                          ? 'a'
                          : ''
                )
            );

        this.scheduleForm
            .get('day_number')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 2 && this.subscriptionData.schedule?.interval
                        ? this.subscriptionData.schedule?.interval
                        : ''
                )
            );

        this.scheduleForm
            .get('week_number')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 3 && this.subscriptionData.schedule?.interval
                        ? this.subscriptionData.schedule?.interval
                        : ''
                )
            );

        this.scheduleForm
            .get('month_number')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 4 && this.subscriptionData.schedule?.daysOfMonth
                        ? this.subscriptionData.schedule?.daysOfMonth
                        : ''
                )
            );

        this.scheduleForm
            .get('fileTypeValue')
            .setValue(String(this.fileTypeList.find((item) => item.key === this.subscriptionData?.subscription?.fileType)?.value ?? ''));
        this.scheduleForm.get('radio_btn_weekly').setValue(String(this.subscriptionData.schedule.recurrenceType == 3 ? 'a' : ''));
        this.scheduleForm
            .get('weekofthemonth')
            .setValue(
                String(
                    this.subscriptionData.schedule.recurrenceType == 4 && this.subscriptionData.schedule?.interval && this.subscriptionData.schedule?.daysOfWeek
                        ? this.subscriptionData.schedule?.interval
                        : ''
                )
            );

        if (this.subscriptionData.schedule.recurrenceType == 4) {
            let binaryNumber = (this.subscriptionData.schedule.monthsOfYear >>> 0).toString(2);
            // Ensure the binary string is 7 characters long (for 7 days)
            const binaryPadded = binaryNumber.padStart(12, '0'); // "1001111"

            // Iterate through the binary string from right to left and map to Days
            this.MonthList.forEach((day, index) => {
                const bit = binaryPadded[binaryPadded.length - 1 - index]; // Get the corresponding bit (right to left)
                day.checked = bit === '1'; // Set checked if bit is 1
                if (day.checked) {
                    this.scheduleForm.get('MonthList').setValue('true');
                }
            });
            if (this.radio_btn_monthly == 'a') {
                let binaryNumber = (this.subscriptionData.schedule.daysOfWeek >>> 0).toString(2);
                // Ensure the binary string is 7 characters long (for 7 days)
                const binaryPadded = binaryNumber.padStart(7, '0'); // "1001111"

                // Iterate through the binary string from right to left and map to Days
                this.Days.forEach((day, index) => {
                    const bit = binaryPadded[binaryPadded.length - 1 - index]; // Get the corresponding bit (right to left)
                    day.checked = bit === '1'; // Set checked if bit is 1
                    this.scheduleForm.get('MonthDay').setValue('true');
                });
            }
        }

        if (this.subscriptionData.schedule.recurrenceType == 3) {
            let binaryNumber = (this.subscriptionData.schedule.daysOfWeek >>> 0).toString(2);
            // Ensure the binary string is 7 characters long (for 7 days)
            const binaryPadded = binaryNumber.padStart(7, '0'); // "1001111"

            // Iterate through the binary string from right to left and map to Days
            this.DayList.forEach((day, index) => {
                const bit = binaryPadded[binaryPadded.length - 1 - index]; // Get the corresponding bit (right to left)
                day.checked = bit === '1'; // Set checked if bit is 1
                this.scheduleForm.get('Weekdays').setValue('true');
            });
        }

        if (this.subscriptionData.schedule.recurrenceType == 2) {
            if (this.radio_btn_daily == 'a') {
                let binaryNumber = (this.subscriptionData.schedule.daysOfWeek >>> 0).toString(2);
                // Ensure the binary string is 7 characters long (for 7 days)
                const binaryPadded = binaryNumber.padStart(7, '0'); // "1001111"

                // Iterate through the binary string from right to left and map to Days
                this.DayListCopy.forEach((day, index) => {
                    const bit = binaryPadded[binaryPadded.length - 1 - index]; // Get the corresponding bit (right to left)
                    day.checked = bit === '1'; // Set checked if bit is 1
                    this.scheduleForm.get('days').setValue('true');
                });
            }
        }

        if (this.reportName == 'Work Flow Template' && this.subscriptionData?.subscription?.parameters) {
            let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
            this.scheduleForm.get('from_date').setValue(String(parameters?.from ? parameters?.from : ''));
        }
    }

    checkDisabled() {
        let tt = this.scheduleForm.get(`radio_btn_weekly`).value != 'a';
        return this.scheduleForm.get(`radio_btn_weekly`).value != 'a';
    }

    changeUnit(event) {
        this.radio_btn_value = this.scheduleForm.get(`radio_btn_value`).value;
        // Method to set validation
        this.scheduleForm.get('week_number')?.disable();
        const textBox = this.scheduleForm.get('hours');
        textBox?.clearValidators();
        textBox?.updateValueAndValidity();
        const radio_btn_daily = this.scheduleForm.get('radio_btn_daily');
        radio_btn_daily?.clearValidators();
        radio_btn_daily?.updateValueAndValidity();
        const radio_btn_weekly = this.scheduleForm.get('radio_btn_weekly');
        radio_btn_weekly?.clearValidators();
        radio_btn_weekly?.updateValueAndValidity();
        const radio_btn_monthly = this.scheduleForm.get('radio_btn_monthly');
        radio_btn_monthly?.clearValidators();
        radio_btn_monthly?.updateValueAndValidity();
        const textBox2 = this.scheduleForm.get('day_number');
        textBox2?.clearValidators();
        textBox2?.updateValueAndValidity();
        const textBox3 = this.scheduleForm.get('days');
        textBox3?.clearValidators();
        textBox3?.updateValueAndValidity();
        const month_number = this.scheduleForm.get('month_number');
        month_number?.clearValidators();
        month_number?.updateValueAndValidity();
        const week_number = this.scheduleForm.get('week_number');
        week_number?.clearValidators();
        week_number?.updateValueAndValidity();
        const Weekdays = this.scheduleForm.get('Weekdays');
        Weekdays?.clearValidators();
        Weekdays?.updateValueAndValidity();
        const MonthDay = this.scheduleForm.get('MonthDay');
        MonthDay?.clearValidators();
        MonthDay?.updateValueAndValidity();
        const MonthList = this.scheduleForm.get('MonthList');
        MonthList?.clearValidators();
        MonthList?.updateValueAndValidity();
        this.scheduleForm.get('radio_btn_weekly').setValue('');
        //Clear Values
        this.scheduleForm.get(`hours`).setValue('');
        this.scheduleForm.get(`radio_btn_daily`).setValue('');
        this.radio_btn_daily = '';
        this.scheduleForm.get(`radio_btn_weekly`).setValue('');
        this.radio_btn_weekly = '';
        this.scheduleForm.get(`radio_btn_monthly`).setValue('');
        this.radio_btn_monthly = '';
        // Set all 'checked' to false
        this.Days.forEach((day) => (day.checked = false));
        this.DayList.forEach((day) => (day.checked = false));
        this.DayListCopy.forEach((day) => (day.checked = false));
        this.scheduleForm.get(`day_number`).setValue('');
        this.scheduleForm.get('month_number')?.disable();
        this.scheduleForm.get(`week_number`).setValue('');
        this.scheduleForm.get('day_number')?.disable();
        this.MonthList.forEach((day) => (day.checked = false));
        if (this.radio_btn_value == '1') {
            //Daily
            const textBox = this.scheduleForm.get('hours');

            textBox?.setValidators([Validators.required, Validators.min(0), Validators.max(23)]);
            textBox?.updateValueAndValidity();
        } else if (this.radio_btn_value == '2') {
            //Daily
            const textBox = this.scheduleForm.get('radio_btn_daily');
            textBox?.setValidators([Validators.required]);
            textBox?.updateValueAndValidity();
        } else if (this.radio_btn_value == '3') {
            //Daily
            // const textBox = this.scheduleForm.get('week_number');
            // textBox?.setValidators([Validators.required, Validators.min(1), Validators.max(52)]);

            // textBox?.updateValueAndValidity();

            this.scheduleForm.get(`radio_btn_weekly`).setValue('a');
            const textBox = this.scheduleForm.get('week_number');
            textBox?.setValidators([Validators.required, Validators.min(1), Validators.max(31)]);
            textBox?.updateValueAndValidity();
            this.scheduleForm.get('week_number')?.enable();

            const Weekdays = this.scheduleForm.get('Weekdays');
            Weekdays?.setValidators([Validators.required]);
            Weekdays?.updateValueAndValidity();
        } else if (this.radio_btn_value == '4') {
            //Daily
            // const textBox = this.scheduleForm.get('week_number');
            // textBox?.setValidators([Validators.required, Validators.min(1), Validators.max(52)]);

            // textBox?.updateValueAndValidity();
            const textBox = this.scheduleForm.get('radio_btn_monthly');
            textBox?.setValidators([Validators.required]);
            textBox?.updateValueAndValidity();
            const MonthList = this.scheduleForm.get('MonthList');
            MonthList?.setValidators([Validators.required]);
            MonthList?.updateValueAndValidity();
        }
    }

    endTimecheck(event: any) {
        let chk = event.checked;
        this.endTimechecked = event.checked;
        if (event.checked) {
            const textBox = this.scheduleForm.get('end_date');
            textBox?.setValidators([Validators.required]);
            textBox?.updateValueAndValidity();
        } else {
            const textBox = this.scheduleForm.get('end_date');
            textBox?.clearValidators();
            textBox?.updateValueAndValidity();
        }
    }

    startTimecheck(checked: any) {
        //let chk = event.checked;
        this.startTimechecked = checked;
        if (checked) {
            const textBox = this.scheduleForm.get('start_hour');
            textBox?.setValidators([Validators.required, Validators.min(0), Validators.max(23)]);
            textBox?.updateValueAndValidity();
            const textBox1 = this.scheduleForm.get('start_minute');
            textBox1?.setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
            textBox1?.updateValueAndValidity();
            this.scheduleForm.get('start_minute')?.enable();
            this.scheduleForm.get('start_hour')?.enable();
        } else {
            const textBox = this.scheduleForm.get('start_hour');
            textBox?.clearValidators();
            textBox?.updateValueAndValidity();
            const textBox1 = this.scheduleForm.get('start_minute');
            textBox1?.clearValidators();
            textBox1?.updateValueAndValidity();
            this.scheduleForm.get('start_minute')?.disable();
            this.scheduleForm.get('start_hour')?.disable();
        }
    }

    DaycheckDaily(event: any, x: any) {
        x.checked = event.checked;
        let chk = this.DayListCopy.some((day) => day.checked);
        this.scheduleForm.get('days').setValue(chk ? 'true' : '');
    }

    WeekDaycheckDaily(event: any, x: any) {
        x.checked = event.checked;
        let chk = this.DayList.some((day) => day.checked);
        this.scheduleForm.get('Weekdays').setValue(chk ? 'true' : '');
    }

    MonthDaycheck(event: any, x: any) {
        x.checked = event.checked;
        let chk = this.Days.some((day) => day.checked);
        this.scheduleForm.get('MonthDay').setValue(chk ? 'true' : '');
    }

    MonthListcheck(event: any, x: any) {
        x.checked = event.checked;
        let chk = this.MonthList.some((day) => day.checked);
        this.scheduleForm.get('MonthList').setValue(chk ? 'true' : '');
    }

    get day_number() {
        return this.scheduleForm.get('day_number');
    }
    get week_number() {
        return this.scheduleForm.get('week_number');
    }
    get month_number() {
        return this.scheduleForm.get('month_number');
    }
    get start_minute() {
        return this.scheduleForm.get('start_minute');
    }
    get start_hour() {
        return this.scheduleForm.get('start_hour');
    }
    get cc_address() {
        return this.scheduleForm.get('cc_address');
    }
    get bcc_address() {
        return this.scheduleForm.get('bcc_address');
    }
    get to_address() {
        return this.scheduleForm.get('to_address');
    }
    get start_date() {
        return this.scheduleForm.get('start_date');
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    // this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    open1(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                size: 'lg',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    // this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    open2(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'custom-class',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    // this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    showpanel() {
        this.showpanelconfirm.emit();
    }

    // shareing data

    instance_next_Tab() {
        this.instance_next_TabEvent.emit((this.message = true));
    }

    transform(items: any[], filterVAlue: string): any {
        return items.filter((i) => i.name.includes(filterVAlue));
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    checkControl(controlname) {
        if (Array.isArray(this.scheduleForm.get(`${controlname}`).value) && this.scheduleForm.get(`${controlname}`).value.length === 0) {
            return false;
        }
        return this.scheduleForm.get(`${controlname}`).value;
    }

    onRadioButtonChange(event) {
        if (event.value == 'a') {
            this.chkDisabled = false;
        } else {
            this.chkDisabled = true;
        }
    }

    submit(type: any) {
        if (!this.scheduleForm.get(`to_address`).value && !this.scheduleForm.get(`cc_address`).value && !this.scheduleForm.get(`bcc_address`).value) {
            this.customToastService.errorToast('Please provide destination email', 'Error');
        } else if (!this.scheduleForm.get(`radio_btn_value`).value) {
            this.customToastService.errorToast('Please select Recurrence Pattern', 'Error');
        } else {
            let startDate = this.scheduleForm.get(`start_date`).value;
            if (!this.subscriptionData?.schedule?.startDate) startDate = formatDateToDDMMMYYYY(startDate);
            if (this.startTimechecked) {
                startDate = startDate + ' ' + this.scheduleForm.get(`start_hour`).value + ':' + this.scheduleForm.get(`start_minute`).value + ':00';
                startDate = this.formatDate(startDate);
            }
            let schedule = {};
            if (this.scheduleForm.get(`radio_btn_value`).value == '1') {
                schedule = {
                    startDate: startDate,
                    recurrenceType: 'Hourly',
                    // enabled: this.enabled,
                    interval: this.scheduleForm.get(`hours`).value,
                };
            } else if (this.scheduleForm.get(`radio_btn_value`).value == '2') {
                if (this.scheduleForm.get(`radio_btn_daily`).value == 'a') {
                    let sumOfCheckedValues = this.DayListCopy.filter((day) => day.checked) // Filter the checked items
                        .reduce((acc, day) => acc + Number(day.value), 0); // Sum their values
                    schedule = {
                        startDate: startDate,
                        recurrenceType: 'Daily',
                        // enabled: this.enabled,
                        daysofWeek: sumOfCheckedValues,
                    };
                } else if (this.scheduleForm.get(`radio_btn_daily`).value == 'b') {
                    let sumOfAllValues = this.Days.reduce((acc, day) => acc + Number(day.value), 0); // Sum all values
                    schedule = {
                        startDate: startDate,
                        recurrenceType: 'Daily',
                        // enabled: this.enabled,
                        daysofWeek: sumOfAllValues,
                    };
                } else if (this.scheduleForm.get(`radio_btn_daily`).value == 'c') {
                    schedule = {
                        startDate: startDate,
                        recurrenceType: 'Daily',
                        // enabled: this.enabled,
                        interval: this.scheduleForm.get(`day_number`).value,
                    };
                }
            } else if (this.scheduleForm.get(`radio_btn_value`).value == '3') {
                let sumOfCheckedValues = this.DayList.filter((day) => day.checked) // Filter the checked items
                    .reduce((acc, day) => acc + Number(day.value), 0); // Sum their values
                schedule = {
                    startDate: startDate,
                    recurrenceType: 'Weekly',
                    // enabled: this.enabled,
                    daysofWeek: sumOfCheckedValues,
                };
                // if (this.scheduleForm.get(`radio_btn_weekly`).value == 'a') {
                schedule['interval'] = this.scheduleForm.get(`week_number`).value;
                // }
            } else if (this.scheduleForm.get(`radio_btn_value`).value == '4') {
                let sumOfCheckedValues = this.MonthList.filter((day) => day.checked) // Filter the checked items
                    .reduce((acc, day) => acc + Number(day.value), 0); // Sum their values
                schedule = {
                    startDate: startDate,
                    recurrenceType: 'Monthly',
                    // enabled: this.enabled,
                    monthsofYear: sumOfCheckedValues,
                };
                if (this.scheduleForm.get(`radio_btn_monthly`).value == 'a') {
                    schedule['interval'] = this.scheduleForm.get(`weekofthemonth`).value;
                    let _sumOfCheckedValues = this.Days.filter((day) => day.checked) // Filter the checked items
                        .reduce((acc, day) => acc + Number(day.value), 0); // Sum their values
                    schedule['daysofWeek'] = _sumOfCheckedValues;
                } else if (this.scheduleForm.get(`radio_btn_monthly`).value == 'b') {
                    schedule['daysofMonth'] = this.scheduleForm.get(`month_number`).value;
                }
            }
            if (this.endTimechecked == true && this.scheduleForm.get(`end_date`).value) {
                schedule['endDate'] = this.scheduleForm.get(`end_date`).value; //this.datePipe.transform(this.scheduleForm.get(`end_date`).value, 'dd-MM-yyyy');
                if (!this.subscriptionData?.schedule?.endDate) schedule['endDate'] = formatDateToDDMMMYYYY(schedule['endDate']);
            }
            if (this.subscriptionData) {
                schedule['scheduleId'] = this.subscriptionData.schedule.scheduleId;
                schedule['enabled'] = this.scheduleForm.get(`enabled`).value;
            } else {
                schedule['enabled'] = true;
            }
            let data = {
                name: this.scheduleForm.get(`Name`).value,
                comments: this.scheduleForm.get(`Description`).value,
                fileType: this.scheduleForm.get(`fileTypeValue`).value,
                to: this.scheduleForm.get(`to_address`).value,
                cc: this.scheduleForm.get(`cc_address`).value,
                bcc: this.scheduleForm.get(`bcc_address`).value,
                subject: this.scheduleForm.get(`Subject`).value,
                runImmediately: type == 2 ? true : false,
                schedule: schedule,
            };

            let parameters = {};
            if (this.reportName == 'Activity Progress') {
                parameters = {
                    projectTypeId: this.scheduleForm.get(`projectTypeId`).value,
                    projectId: this.scheduleForm.get(`projectId`).value,
                };
                data['parameters'] = JSON.stringify(parameters);
            } else if (this.reportName == 'Work Flow Completion') {
                parameters = {
                    activityPackTypeIds: this.scheduleForm.get(`selectAll`).value == true ? ['selectall'] : this.checkedIds,
                };

                data['parameters'] = JSON.stringify(parameters);
            } else if (this.reportName == 'View Hierarchy') {
                parameters = {
                    viewId: this.scheduleForm.get(`viewId`).value,
                };
                data['parameters'] = JSON.stringify(parameters);
            } else if (this.reportName == 'Work Flow Template') {
                let param;
                if (this.subscriptionData?.subscription?.parameters) {
                    param = JSON.parse(this.subscriptionData?.subscription?.parameters);
                }
                parameters = {
                    activityPackTypeId: this.activityPackTypeId,
                    activityPackTypeStatusIds:
                        this.scheduleForm.get(`activityPackTypeStatusselectAll`).value == true
                            ? ['selectall']
                            : this.activityPackTypeStatusSelected
                              ? this.activityPackTypeStatusSelected.map((x) => x.activityPackTypeStatusId)
                              : null,
                    activityPackIds:
                        this.scheduleForm.get(`activityPackIdselectAll`).value == true
                            ? ['selectall']
                            : this.activityPackSelected
                              ? this.activityPackSelected
                              : null,
                    from:
                        this.scheduleForm.get('from_date').value && !param?.from
                            ? formatDateToDDMMMYYYY(this.scheduleForm.get('from_date').value)
                            : this.scheduleForm.get('from_date').value,
                };
                data['parameters'] = JSON.stringify(parameters);
            }
            if (this.subscriptionData) {
                data['subscriptionId'] = this.subscriptionData.subscription.subscriptionId;
                this.mgmtApi.putSubscriptions(this.reportId, [data]).subscribe(
                    (response: any) => {
                        if (response.success) {
                            this.ngbActiveModal.close(true);
                            this.cd.detectChanges();

                            if (type == 1) {
                                this.customToastService.successToast('Report subscription updated successfully!', 'Success');
                            } else {
                                this.customToastService.successToast('Report subscription updated and report sent successfully!', 'Success');
                            }
                        } else {
                            // this.customToastService.errorToast(response.message, 'Error');
                            this.customToastService.errorToast('Unable to send the report. Please try again or contact system administrator.', 'Error');
                        }
                    },
                    (error) => {
                        this.customToastService.errorToast('Unable to send the report. Please try again or contact system administrator.', 'Error');
                    }
                );
            } else {
                this.mgmtApi.postSubscriptions(this.reportId, [data]).subscribe(
                    (response: any) => {
                        if (response.success) {
                            this.ngbActiveModal.close(true);
                            this.cd.detectChanges();

                            if (type == 1) {
                                this.customToastService.successToast('Report subscription created successfully!', 'Success');
                            } else {
                                this.customToastService.successToast('Report subscription created and report sent successfully!', 'Success');
                            }
                        } else {
                            this.customToastService.errorToast(response.message, 'Error');
                        }
                    },
                    (error) => {
                        this.customToastService.errorToast('Error', 'Error');
                    }
                );
            }
        }
    }

    searchResult(event, type) {
        switch (type) {
            case 'activityPackTypeId':
                this.activityPackTypes = this.filterData(event, this.activityPackTypesCopy);
                break;
            case 'viewId':
                this.Views = this.filterData(event, this.ViewsCopy);
                break;
            case 'activityPackTypeStatusId':
                this.activityPackStatus = this.filterData(event, this.activityPackStatusCopy);
                break;
            case '_activityPackTypeId':
                this.activityPackTypes = this.filterData(event, this.activityPackTypesCopy);
                break;
            case 'projectId':
                this.projects = this._filterData(event, this.projectsCopy);
                break;
            case 'projectTypeId':
                this.projectTypes = this.filterData(event, this.projectTypesCopy);
                break;
            case 'activityPackId':
                this.activityPacks = this._filterData(event, this.activityPacksCopy);
                break;
        }
    }
    filterData(event, optionList) {
        let result: any[] = [];
        if (!event.target.value) {
            result = optionList;
        } else {
            result = optionList.filter((item) => {
                return (item.name !== undefined ? item.name : '')
                    .trim()
                    .toLowerCase()
                    .replace(' ', '')
                    .includes(event.target.value.trim().replace(' ', '').toLowerCase());
            });
        }
        return result;
    }
    _filterData(event, optionList) {
        let result: any[] = [];
        if (!event.target.value) {
            result = optionList;
        } else {
            result = optionList.filter((item) => {
                return (item.namePrimary !== undefined ? item.namePrimary : '')
                    .trim()
                    .toLowerCase()
                    .replace(' ', '')
                    .includes(event.target.value.trim().replace(' ', '').toLowerCase());
            });
        }
        return result;
    }
    async getAllActivityPacks() {
        this.ngxUiLoaderService.start();
        try {
            let url = `getreportdata/${this.reportId}`;

            const _ActivityPacks = await this.reportApiService.getAllActivityPacks(url).toPromise();
            if (_ActivityPacks.success) {
                this.activityPackTypes = this.activityPackTypesCopy = _ActivityPacks.response;
                if (this.subscriptionData?.subscription?.parameters) {
                    let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                    if (this.reportName == 'Work Flow Completion') {
                        if (parameters.activityPackTypeIds[0] == 'selectall') {
                            this.selectedOptions = this.activityPackTypesCopy.map((x) => x.activityPackTypeId);
                            this.scheduleForm.get('selectAll').setValue(true, { emitEvent: false });
                        } else {
                            this.selectedOptions = this.activityPackTypesCopy
                                .filter((item) => parameters.activityPackTypeIds.includes(item.activityPackTypeId))
                                .map((item) => item.activityPackTypeId);
                        }
                    } else {
                        this.activityPackTypeId = parameters?.activityPackTypeId;
                        this.scheduleForm.get(`_activityPackTypeId`).setValue(parameters?.activityPackTypeId);

                        // let activityPackType = {
                        //     activityPackTypeId: String(parameters?.activityPackTypeId),
                        // };
                        // this.activityPackTypeId = String(parameters?.activityPackTypeId);
                        // this.getAllActivityStatus(activityPackType);
                        // this.getAllActivityStatus(parameters?.activityPackTypeId);
                    }
                }
                if (this.activityPackTypes?.length == 1) {
                    this.activityPackTypeId = this.activityPackTypes[0].activityPackTypeId;

                    if (this.reportName == 'Work Flow Completion') {
                        this.scheduleForm
                            .get('activityPackTypeId')
                            .setValue(this.activityPackTypes[0].activityPackTypeId ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : []);
                    } else if (this.reportName == 'Work Flow Template') {
                        this.scheduleForm.get('activityPackTypeId').patchValue(this.activityPackTypes[0].activityPackTypeId, { emitEvent: true });
                    }
                }
            } else {
                this.user_utlity.errorModelPopup(_ActivityPacks.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getAllActivityStatus(activityPackType: any) {
        this.ngxUiLoaderService.start();
        try {
            const Activity_Packs = await this.reportApiService.getAllActivityPacks(`getreportdata/${this.reportId}`, activityPackType).toPromise();
            if (Activity_Packs.success) {
                if (activityPackType?.activityPackTypeStatusIds) {
                    this.activityPacks = this.activityPacksCopy = Activity_Packs.response;
                    if (this.subscriptionData?.subscription?.parameters) {
                        let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                        if (parameters.activityPackIds) {
                            if (parameters.activityPackIds[0] == 'selectall') {
                                this.activityPackSelected = this.activityPacksCopy.map((x) => x.activityPackId);
                                this.scheduleForm.get('activityPackIdselectAll').setValue(true, { emitEvent: false });
                            } else {
                                this.activityPackSelected = this.activityPacksCopy
                                    .filter((item1) => parameters.activityPackIds.find((item2) => item1.activityPackId === item2))
                                    .map((x) => x.activityPackId);
                            }
                        }
                    }
                    if (this.activityPacks?.length == 1) {
                        this.scheduleForm
                            .get('activityPackId')
                            .setValue(this.activityPacks[0].activityPackId ? this.activityPacksCopy.map((x) => x.activityPackId) : []);
                    }
                } else {
                    this.activityPackStatus = this.activityPackStatusCopy = Activity_Packs.response;
                    this.cd.detectChanges();
                    if (this.subscriptionData?.subscription?.parameters) {
                        let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                        if (parameters.activityPackTypeStatusIds) {
                            if (parameters.activityPackTypeStatusIds[0] == 'selectall') {
                                this.activityPackTypeStatusSelected = this.activityPackStatusCopy;
                                this.scheduleForm.get('activityPackTypeStatusselectAll').setValue(true, { emitEvent: false });
                            } else {
                                this.activityPackTypeStatusSelected = this.activityPackStatusCopy.filter((item1) =>
                                    parameters.activityPackTypeStatusIds.find((item2) => item1.activityPackTypeStatusId === item2)
                                );
                            }
                            this.cd.detectChanges();
                            this.activityPackStatusIds = this.activityPackTypeStatusSelected.map((x) => x.activityPackTypeStatusId);
                            //this.scheduleForm.get('activityPackTypeStatusId').setValue(this.activityPackTypeStatusSelected.map((x) => x.activityPackTypeStatusId));
                            let activityPackType = {
                                activityPackTypeId: this.activityPackTypeId,
                                activityPackTypeStatusIds: this.activityPackTypeStatusSelected.map((x) => x.activityPackTypeStatusId),
                            };

                            this.getAllActivityStatus(activityPackType);
                        }
                    } else if (this.activityPackStatus?.length == 1) {
                        this.scheduleForm
                            .get('activityPackTypeStatusId')
                            .setValue(this.activityPackStatus[0].activityPackTypeStatusId ? [this.activityPackStatusCopy[0]] : []);
                        this.activityPackTypeStatusSelected = this.activityPackStatusCopy;
                    }
                }
            } else {
                this.user_utlity.errorModelPopup(Activity_Packs.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getAllViews() {
        this.ngxUiLoaderService.start();
        try {
            const Views = await this.reportApiService.getAllViews(this.reportId).toPromise();
            if (Views.success) {
                this.Views = this.ViewsCopy = Views.response;
                if (this.subscriptionData?.subscription?.parameters) {
                    let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                    this.scheduleForm.get('viewId').setValue(parameters?.viewId);
                } else if (this.Views?.length == 1) {
                    this.checkedIds = this.Views[0].viewId;
                    this.scheduleForm.get('viewId').patchValue(this.Views[0].viewId, { emitEvent: true });
                }
            } else {
                this.user_utlity.errorModelPopup(Views.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getProjectTypesAndProjects() {
        let projecttypeId = this.scheduleForm.get('projectTypeId').value;
        let projectId = this.scheduleForm.get('projectId').value;
        let payLoad = {};
        payLoad = projectId && projecttypeId ? { projectId: projectId } : projecttypeId && !projectId ? { projectTypeId: projecttypeId } : payLoad;

        this.ngxUiLoaderService.start();
        try {
            const project_Data = await this.reportApiService.getProjectTypesAndProjects(`getreportdata/${this.reportId}`, payLoad).toPromise();
            if (project_Data.success) {
                if (!projecttypeId && !projectId) {
                    this.projectTypes = this.projectTypesCopy = project_Data.response;
                    if (this.subscriptionData?.subscription?.parameters) {
                        let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                        this.scheduleForm.get('projectTypeId').setValue(parameters?.projectTypeId);
                        // this.getProjectTypesAndProjects();
                    } else if (this.projectTypes?.length == 1) {
                        this.scheduleForm.get('projectTypeId').setValue(this.projectTypes[0].projectTypeId ? this.projectTypes[0].projectTypeId : '');
                    }
                } else if (!projectId && projecttypeId) {
                    this.projects = this.projectsCopy = project_Data.response;
                    if (this.subscriptionData?.subscription?.parameters) {
                        let parameters = JSON.parse(this.subscriptionData?.subscription?.parameters);
                        this.scheduleForm.get('projectId').setValue(parameters?.projectId);
                    } else if (this.projects?.length == 1) {
                        this.scheduleForm.get('projectId').setValue(this.projects[0].projectId ? this.projects[0].projectId : '');
                    }
                } else {
                    // this.ActivityProgressData = project_Data.response;
                }
            } else {
                this.user_utlity.errorModelPopup('Failed to load data!!');
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup('Failed to load data!!');
        }
    }

    formatDate(dateStr: string) {
        const formattedDate = this.datePipe.transform(dateStr, 'dd-MMM-yyyy HH:mm:ss');
        return formattedDate;
    }

    onDateChange(event: any) {
        const dateStr = event.target.value;
        let date = new Date(dateStr);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        this.scheduleForm.get('start_date').setValue(this.datePipe.transform(`${year}-${month}-${day}, 'yyyy-MM-dd')`));
        // this.formattedDate = this.formatDate(yourDate);
    }

    // minDateStart: any = new Date();
    startDatedetectValueChanges(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;
        this.scheduleForm.get('start_date').setValue(this._formatDate(selectedDate));
    }

    endDatedetectValueChanges(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;
        this.scheduleForm.get('end_date').setValue(this._formatDate(selectedDate));
    }

    detectValueChanges(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;
        this.fromDate = this._formatDate(selectedDate);
    }

    removeSubscription() {
        let data = {
            data: this.subscriptionData,
        };
        this.RemoveEvent.emit(data);
    }

    viewActivityPackStatus() {
        return this.scheduleForm.get('_activityPackTypeId').value ? true : false;
    }

    viewActivityPack() {
        return this.activityPackStatusIds?.length > 0 ? true : false;
    }

    private _formatDate(date: Date): string {
        if (date) {
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        }
        return null;
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
    onDateBoxOpened(e: any) {
        const instance = e.component;
        if (!instance.option('value')) {
            const today = new Date();
            instance.option('openedDate', today); // force calendar to show today’s month
        }
    }
}
function formatDateToDDMMMYYYY(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2); // 2-digit day
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()]; // 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}
// Regular expression for validating an email address
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const numberRegex = /^\d+$/;

// Custom Validator function
export function commaSeparatedEmailsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const inputValue = control.value;

        if (!inputValue) {
            // If the input is empty, it's valid because it's not mandatory
            return null;
        }

        // Split the input by commas and trim extra spaces
        const emails = inputValue.split(';').map((email) => email.trim());

        // Validate each email against the regex
        const invalidEmails = emails.filter((email) => !emailRegex.test(email));

        // If there are invalid emails, return an error object
        if (invalidEmails.length > 0) {
            return { invalidEmails: invalidEmails };
        }

        // If all emails are valid, return null (no error)
        return null;
    };
}

// Custom Validator function
export function commaSeparatedNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const inputValue = control.value;

        if (!inputValue) {
            // If the input is empty, it's valid because it's not mandatory
            return null;
        }

        // Split the input by commas and trim extra spaces
        const numbers = inputValue.split(',').map((number) => number.trim());

        // Validate each email against the regex
        const invalidnumbers = numbers.filter((number) => !numberRegex.test(number));

        // If there are invalid emails, return an error object
        if (invalidnumbers.length > 0) {
            return { invalidNumbers: invalidnumbers };
        } else {
            const invalidnumbers = numbers.filter((number) => !(number >= 1 && number <= 31));
            if (invalidnumbers.length > 0) {
                return { invalidNumbers: invalidnumbers };
            }
        }
        // Convert the string to a number
        //const numberValue = Number(value);

        // Check if the number is between 1 and 31
        //return numberValue >= 1 && numberValue <= 31;
        // If all emails are valid, return null (no error)
        return null;
    };
}
